import { Select, type SelectProps } from "./Select";
import { GlobalStyles, MenuItem } from "~/common/mui";

type Props = SelectProps & {
  itemsPerRow: number;
};

const CALENDAR_LIST_CLASS = "scha-calendar-select-list";

export const CalendarLikeSelect = ({ itemsPerRow, MenuProps = {}, ...rest }: Props) => {
  return (
    <>
      <GlobalStyles
        styles={(theme) => ({
          [`.${CALENDAR_LIST_CLASS}`]: {
            display: "grid",
            gridTemplateColumns: `repeat(var(--column-amount, 1), minmax(0, 1fr))`,
            padding: 0,
            "& .MuiMenuItem-root": {
              ...theme.typography.labelLarge,
              display: "flex",
              justifyContent: "center",
              padding: `${theme.spacing(1.25)} 0`,
            },
          },
        })}
      />
      <Select
        variant={"outlined"}
        MenuProps={{
          ...MenuProps,
          style: {
            ...MenuProps.style,
            // @ts-ignore
            "--column-amount": itemsPerRow,
          },
          classes: {
            ...MenuProps?.classes,
            list: `${CALENDAR_LIST_CLASS} ${MenuProps?.classes?.list ?? ""}`.trim(),
          },
        }}
        {...rest}
      />
    </>
  );
};

CalendarLikeSelect.Item = MenuItem;
